export default "__VITE_ASSET__DVsFDvpS__"